const ENV = {
  TOKEN_DESCRIPTIONS: {
    WFTM: "WFTM is the wrapped version of FTM, used for standardizing interactions with ERC20 tokens. FTM is the primary token on the Fantom network. FTM is used for securing the network through staking, for governance, for payments, and for fees.",
  },
};

export default ENV;
